import brand from '@helpers/brand';
import { css, FlattenSimpleInterpolation, SimpleInterpolation } from 'styled-components';

export default {
  navHeight: 76,
  navHeightSmall: 68,
  contentPadding: 24,
  rootMarginValues: '0px 0px -20% 0px',
};

export function customScrollbar(scrollbarBG = brand.grey[90], thumbBG = brand.grey[65]): FlattenSimpleInterpolation {
  return css`
    /* scrollbar-width: thin; */
    scrollbar-color: ${thumbBG} ${scrollbarBG};

    &::-webkit-scrollbar {
      width: 11px;
    }
    &::-webkit-scrollbar-track {
      background: ${scrollbarBG};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${thumbBG};
      border-radius: 6px;
      border: 3px solid ${scrollbarBG};
    }
  `;
}

export const legacyStylesOverride = (styled: SimpleInterpolation): SimpleInterpolation => css`
  .CSCZ .mainContent &,
  .HUHU .mainContent &,
  .PLPL .mainContent &,
  .RURU .mainContent &,
  .SKSK .mainContent &,
  .RORO .mainContent &,
  .BGBG .mainContent &,
  .HRHR .mainContent &,
  .mainContent & {
    ${styled}
  }
`;

export const dsStylesOverride = (styled: SimpleInterpolation): SimpleInterpolation => css`
  .ds & {
    ${styled}
  }
`;

export const ButtonReset = css`
  border: none;
  outline: none;
  padding: 0px;
  background: none;
  border-radius: 0px;
`;
